<template>
  <b-field>
    <p class="control">
      <span class="button is-static">Sortierung</span>
    </p>
    <b-select
      :value="value"
      icon="sort"
      expanded
      @input="$emit('input', $event)"
    >
      <option
        v-for="option in options"
        :key="option.field"
        :value="option.field"
      >
        {{ option.label }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  name: "SortSelect",
  props: {
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => [
        { field: "frontendorder", label: "Sortierung" },
        { field: "name", label: "Name" },
        { field: "code", label: "Code" },
        { field: "id", label: "ID" }
      ]
    }
  }
};
</script>
